import React from "react";
import { ShieldCheckIcon, CheckIcon } from "lucide-react";
import { CTAButton } from "./CTAButton";
const steps = ["Explore all six volumes.", "Review the five specialized tools.", "Examine the worksheets and checklists.", "Explore the visual navigation framework.", "Assess whether the organization suits your needs."];
export function Guarantee() {
  return <section className="w-full bg-white px-4 py-16 sm:py-20" data-id="element-158" data-mp="19eqyzm9pcdob">
      <div className="mx-auto max-w-3xl text-center" data-id="element-159" data-mp="19f0o77mxagsy">
        <div className="mx-auto flex h-28 w-28 flex-col items-center justify-center rounded-full border-4 border-gold bg-navy text-gold" data-id="element-160" data-mp="14g63u19b4k6q">
          <ShieldCheckIcon className="h-9 w-9" aria-hidden="true" data-id="element-161" data-mp="1j6554cw5sbqf" />
          <span className="mt-1 font-serif text-2xl font-black leading-none" data-id="element-162" data-mp="1edk872hyhiio">7</span>
          <span className="text-[10px] font-bold uppercase tracking-widest" data-id="element-163" data-mp="qnpy2sp0u824">Days</span>
        </div>

        <p className="mt-6 text-xs font-bold uppercase tracking-[0.14em] text-gold-dark sm:text-sm" data-id="element-164" data-mp="lpoiwiupusvx">The 7-day money-back guarantee</p>
        <h2 className="mt-3 font-serif text-[30px] font-bold leading-[1.12] text-navy sm:text-4xl md:text-5xl" data-id="element-165" data-mp="oz05a0jmgaqy">
          Explore the complete system before deciding whether it's right for you
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-[17px] leading-relaxed text-muted sm:text-lg" data-id="element-166" data-mp="ypurx60s5ccx">
          I want you to have the opportunity to explore Insulin Resistance Nutrition Blueprint™ and decide whether it fits your
          professional workflow. After purchasing, you can:
        </p>

        <ul className="mx-auto mt-6 max-w-md space-y-3 text-left" data-id="element-167" data-mp="b0a5ue9bxyzf">
          {steps.map(s => <li key={s} className="flex items-start gap-3 text-[16px] text-ink" data-id="element-168" data-mp="ezsiynuwt5rp">
              <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-cta text-white" data-id="element-169" data-mp="k1822adj127g">
                <CheckIcon className="h-4 w-4" strokeWidth={3} aria-hidden="true" data-id="element-170" data-mp="1qg90qntxryhq" />
              </span>
              {s}
            </li>)}
        </ul>

        <div className="mx-auto mt-8 max-w-2xl space-y-3 rounded-2xl bg-cream p-5 text-[16px] leading-relaxed text-muted sm:p-7" data-id="element-171" data-mp="3rhyrm0oh4uf5">
          <p data-id="element-172" data-mp="3nglohycrn5bx">
            If, within seven days of your purchase, you decide the collection is not the right fit, you can contact us to request
            a refund under the stated guarantee terms.
          </p>
          <p className="font-semibold text-ink" data-id="element-173" data-mp="achbp791tpb">
            You have seven days to evaluate the materials. No need to commit to an ongoing subscription.
          </p>
          <p data-id="element-174" data-mp="33ugurqqcr65b">Just review the resources and decide whether they are useful for your work.</p>
        </div>

        <div className="mt-10" data-id="element-175" data-mp="3iitripx9kt0v">
          <CTAButton label="Get Insulin Resistance Nutrition Blueprint™ risk-free" note="One-Time Payment of $27 USD · 7-Day Money-Back Guarantee" data-id="element-176" data-mp="3ijv797p863ox" />
        </div>
      </div>
    </section>;
}